import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { providerProblem, type ProviderDraft } from '@/lib/lis/orderingProvider'

/**
 * The ordering provider (ORC-12 / OBR-16) of an outgoing mapping's releases
 * (z8nrz7fdc0). They go unsolicited, so there is no order to take one from:
 * this one is sent, else the LIS Stages setup of the same order code, and with
 * neither a release is refused.
 */
export function MappingProviderFields({
  idPrefix,
  value,
  onChange,
}: {
  idPrefix: string
  value: ProviderDraft
  onChange: (value: ProviderDraft) => void
}) {
  const set = (key: keyof ProviderDraft, v: string) => onChange({ ...value, [key]: v })
  const problem = providerProblem(value)
  return (
    <div className='grid gap-1.5'>
      <Label htmlFor={`${idPrefix}-npi`}>
        Ordering provider (OBR-16) <span className='font-normal text-muted-foreground'>(optional)</span>
      </Label>
      <div className='grid gap-2 sm:grid-cols-4'>
        <Input
          id={`${idPrefix}-npi`}
          aria-label='Ordering provider NPI'
          value={value.npi}
          onChange={(e) => set('npi', e.target.value)}
          placeholder='NPI (10 digits)'
          inputMode='numeric'
          className='font-mono'
        />
        <Input
          aria-label='Ordering provider last name'
          value={value.lastName}
          onChange={(e) => set('lastName', e.target.value)}
          placeholder='Last name (optional)'
        />
        <Input
          aria-label='Ordering provider first name'
          value={value.firstName}
          onChange={(e) => set('firstName', e.target.value)}
          placeholder='First name (optional)'
        />
        <Input
          aria-label='Ordering provider middle name'
          value={value.middleName}
          onChange={(e) => set('middleName', e.target.value)}
          placeholder='Middle name (optional)'
        />
      </div>
      {problem ? (
        <p className='text-xs text-destructive'>{problem}</p>
      ) : (
        <p className='text-[11px] text-muted-foreground'>
          Left empty, the provider set for this order code in Configure → LIS Stages is sent. With neither, Epic
          would get no ordering provider, so the release is refused.
        </p>
      )}
    </div>
  )
}
